import React from 'react';
import styled from '@emotion/styled';
import { Flex } from 'rebass';

const StyledThirdPaneContent = styled(Flex)`
  overflow-y: scroll;
  flex-grow: 1;
  flex-direction: column;
`;

export default StyledThirdPaneContent;
